if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.dialog = this.querySelector('dialog');
        this.content = this.querySelector('[role="document"]');
        this.previous = this.querySelector('[data-media-previous]');
        this.next = this.querySelector('[data-media-next]');
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.hide();
        });
        this.dialog.addEventListener('close', () => {
          if (!this.hasAttribute('open') && this.openedBy?.isConnected) this.openedBy.focus({ preventScroll: true });
        });
        this.previous?.addEventListener('click', () => this.moveMedia(-1));
        this.next?.addEventListener('click', () => this.moveMedia(1));
        this.dialog.addEventListener('pointerup', (event) => event.stopPropagation());
        this.dialog.addEventListener('keydown', (event) => {
          if (event.key === 'Tab') {
            const controls = getFocusableElements(this.dialog).filter((element) => element.getClientRects().length);
            const first = controls[0], last = controls[controls.length - 1];
            if ((event.shiftKey && event.target === first) || (!event.shiftKey && event.target === last)) {
              event.preventDefault();
              (event.shiftKey ? last : first)?.focus();
            }
            return;
          }
          if (event.target.closest('video, iframe, product-model')) return;
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.moveMedia(event.key === 'ArrowRight' ? 1 : -1);
        });
        this.content.addEventListener('touchstart', (event) => {
          this.touchStart = event.touches.length === 1 && event.target.tagName === 'IMG'
            ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
        }, { passive: true });
        this.content.addEventListener('touchend', (event) => {
          if (!this.touchStart || event.touches.length || window.visualViewport?.scale > 1) return;
          const dx = event.changedTouches[0].clientX - this.touchStart.x;
          const dy = event.changedTouches[0].clientY - this.touchStart.y;
          this.touchStart = null;
          if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) this.moveMedia(dx < 0 ? 1 : -1);
        }, { passive: true });
      }

      hide() {
        if (!this.hasAttribute('open')) return;
        this.dialog.close();
        super.hide();
      }

      disconnectedCallback() {
        if (this.hasAttribute('open')) this.hide();
      }

      show(opener) {
        super.show(opener);
        this.dialog.showModal();
        this.showActiveMedia();
        removeTrapFocus();
        this.querySelector('.product-media-modal__toggle').focus({ preventScroll: true });
      }

      get mediaItems() {
        return Array.from(this.content.children).filter((element) => element.hasAttribute('data-media-id'));
      }

      moveMedia(direction) {
        const items = this.mediaItems;
        const index = items.findIndex((element) => element.classList.contains('active'));
        const item = items[index + direction];
        if (item) this.showActiveMedia(item.dataset.mediaId);
      }

      showActiveMedia(mediaId = this.openedBy.getAttribute('data-media-id')) {
        const items = this.mediaItems;
        const activeMedia = items.find((element) => element.dataset.mediaId === mediaId) || items[0];
        if (!activeMedia) return;
        window.pauseAllMedia();
        items.forEach((element) => element.classList.toggle('active', element === activeMedia));
        this.content.scrollTo(0, 0);
        const index = items.indexOf(activeMedia);
        if (this.previous) this.previous.disabled = index === 0;
        if (this.next) this.next.disabled = index === items.length - 1;
        const current = this.querySelector('[data-media-current]');
        if (current) current.textContent = index + 1;
        const total = this.querySelector('[data-media-total]');
        if (total) total.textContent = items.length;
        if (activeMedia.nodeName === 'DEFERRED-MEDIA') {
          activeMedia.loadContent(false);
          activeMedia.querySelector('video')?.play()?.catch(() => {});
        }
      }
    }
  );
}
